export default "__VITE_ASSET__B_7weG5n__"